module.exports = __webpack_public_path__ + "img/swiper_08.78de174b.jpg";